import { StyledFormInputWrapper } from 'styles/formStyles.css'
import { StyledPanelWrapper } from 'styles/panelStyles.css'
import { FormikProvider } from 'formik'
import FormikTextField from 'components/TextFieldFormik/TextFieldFormik'
import TextareaFormik from 'components/TextareaFormik'
import UploadImage from 'components/UploadImage'
import { useGenerateUploadUrlService, useUploadFileService } from 'services/useFileService'
import { useState } from 'react'
import { StyledRow } from '../../Playground/Subnets/Cortext/Settings/SettingsStyles.css'
import TextField from 'share-ui/components/TextField/TextField'

const default_logo = 'https://img.cryptorank.io/coins/bittensor1670850707129.png'

const SettingsPanel = ({ formik }: any) => {
    const { generateUploadUrlService } = useGenerateUploadUrlService()
    const { uploadFileService } = useUploadFileService()

    const [uploadFileLoader, setUploadFileLoader] = useState(false)

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        setUploadFileLoader(true)
        const { files } = event.target
        if (!files) {
            setUploadFileLoader(false)
            return
        }

        try {
            const [file] = files
            const data = {
                name: file.name,
                type: file.type,
                size: file.size,
            }

            const { signed_url, file_url } = await generateUploadUrlService(data)

            await uploadFileService(signed_url, file)

            formik.setFieldValue('logo', file_url)
        } catch (error) {
            console.error('File upload failed:', error)
        } finally {
            setUploadFileLoader(false)
        }
    }

    const handleRemoveLogo = () => {
        formik.setFieldValue('logo', default_logo)
    }

    return (
        <>
            <FormikProvider value={formik}>
                <StyledPanelWrapper>
                    <StyledFormInputWrapper noPadding style={{ paddingLeft: '5px' }}>
                        <FormikTextField label='Name' name='name' placeholder='name' />

                        <TextareaFormik
                            label={'Description'}
                            value={formik.values.description}
                            fieldName={'description'}
                            placeholder='description'
                        />

                        {[...formik.values?.configs?.providers || []].map((provider: any, index: number) => (
                            <StyledRow key={index} style={{ columnGap: "15px" }}>

                                <TextField
                                    placeholder='Provider'
                                    type={TextField.types?.TEXT}
                                    value={provider.name}
                                    onChange={(value: string) => formik.setFieldValue(`configs.providers[${index}].name`, value)}
                                    title="Provider"
                                    disabled
                                />

                                <TextField
                                    placeholder='Model'
                                    type={TextField.types?.TEXT}
                                    value={provider.model}
                                    onChange={(value: string) => formik.setFieldValue(`configs.providers[${index}].model`, value)}
                                    title="Model"
                                    disabled
                                />

                                {provider.type === "image_generation" &&
                                    <TextField
                                        placeholder='Size'
                                        type={TextField.types?.TEXT}
                                        value={provider.size}
                                        onChange={(value: string) => formik.setFieldValue(`configs.providers[${index}].size`, value)}
                                        title="Size"
                                        disabled
                                    />
                                }


                                <TextField
                                    placeholder='Price'
                                    type={TextField.types?.TEXT}
                                    value={provider.price_per_token}
                                    onChange={(value: string) => formik.setFieldValue(`configs.providers[${index}].price_per_token`, value)}
                                    title={provider.type === "text_generation" ? "Price" : "Price for Image Request"}
                                />

                                {provider.type === "text_generation" && (
                                    <TextField
                                        placeholder='Batch tokens'
                                        type={TextField.types?.TEXT}
                                        value={provider.batch_tokens}
                                        onChange={(value: string) => formik.setFieldValue(`configs.providers[${index}].batch_tokens`, value)}
                                        title="Batch tokens"
                                    />
                                )}

                            </ StyledRow>
                               
                        ))}

                        {/* <StyledRow>
                            <FormikTextField
                                label='Price'
                                name='price_per_token'
                                placeholder='price_per_token'
                                type='number'
                                tooltip={`Displayed Price is for ${formik.values.limit} tokens`}
                            />

                            <FormikTextField
                                label='Quantity'
                                name='limit'
                                placeholder='Quantity'
                                type='number'
                            />
                        </StyledRow>

                        <FormikTextField
                            label='Price for Image Request'
                            name='price_per_request'
                            placeholder='Price for Image Request'
                            type='number'
                        /> */}

                        <UploadImage
                            buttonLabel='Upload Logo'
                            loading={uploadFileLoader}
                            value={formik.values.logo}
                            onChange={handleFileChange}
                            remove={handleRemoveLogo}
                            hideRemove={!uploadFileLoader && formik.values.logo !== default_logo}
                        />
                    </StyledFormInputWrapper>
                </StyledPanelWrapper>
            </FormikProvider>
        </>
    )
}

export default SettingsPanel
